import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const Treatmentpackages = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { selectedPackage,providerDetails,selectedPackageName} =location.state || {};
  const token = localStorage.getItem('AccessToken');
  const contract = useSelector((state) => state.userData.userData.ContractIdentified);
  const memberid = useSelector((state) => state.userData.userData.MemberID);
  const emailid = useSelector((state) => state.userData.userData.EmailID);
  const [costDetails, setCostDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate= useNavigate();

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  
  useEffect(() => {
    const fetchTreatmentCostDetails = async () => {
          
      const params = {
        CPTCode: selectedPackage,
        GroupID: providerDetails?.GroupID || "",
        Contract: contract,
        MemberID: memberid,
        DeviceType:"PatientPortal",
        EmailID:emailid
      };

      try {
        const response = await axios.post(
          Endpoints.GetTreatmentCostEstimator,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            }
          }
        );
        if (response.data && response.status==200) {
          setCostDetails(response.data);
        }
      } 
      finally {
        setLoading(false);
      }
    };

    fetchTreatmentCostDetails();
  }, [selectedPackage, providerDetails, contract, memberid]);

   if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };
  return (
    <>

{isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">{t('treatmentcost')}</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
              {t('Back')}
            </span>
          </button>       
          <h2 className="page-heading">{t('treatmentcost')}</h2>
        </div>
      }


        {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('back')}</span></button>
          <h2 className="page-heading">{t('treatmentcost')}</h2>
        </div> */}
        
        <div className="mb-5 mt-5">
          <h4 className="page-heading-secondary-gray mb-4">{t('treatmentpackage')}</h4>
          <h2 className="page-heading-bold-primary-20">
            {selectedPackageName}
          </h2>
          {/* <p className="note-gray-bold-16">{t('treatmenttext')}</p> */}
        <p className="note-gray-bold-16">
  The estimated out-of-pocket cost provided by this tool is for informational purposes only and is not a guarantee of the actual amount you will owe.<br /><br />
  Please keep in mind:<br />
   <ul style={{ paddingLeft: "1.2em", marginBottom: 0 }}>
    <li>Your actual costs may vary depending on the specific services you receive.</li>
    <li>These costs are for in-network providers.</li>
    <li>This estimate is not a guarantee of coverage, and your health plan benefits are subject to change.</li>
    <li>This is not a substitute for a pre-authorization or pre-determination of benefits. Contact your Provider or your Nurse Care Advocate for further information.</li>
  </ul>
</p>

        </div>        <div className="d-flex flex-column gap-2">
  {costDetails
     .filter(item => item.Name !== "CostShareFlag" && item.value !== "" && item.value !== "0" && item.Name !="") // Filter out CostShareFlag and empty values
    .sort((a, b) => a.SortOrder - b.SortOrder) // Sort by SortOrder
    .map((item, index) => (
      <div
        key={index}
        className="cost-breakup-row-wrapper"
      >
        <span className="text-black">
          {item.Name}
        </span>
        <span className="text-black text-bold">
          {item.value}
        </span>
      </div>
    ))}
</div>       {(['Benefit Limit', 'Utilization', 'Estimated Remaining Balance'].every(name =>
            costDetails.some(item => 
              item.Name === name && 
              item.value !== "" && 
              item.value !== "0"
            )
        ) ? (
          <p className="note-gray-bold-16 mt-4">
            (Benefit Limit, Potential Utilization, and Estimated Remaining Balance are only displayed for LTM clients)
          </p>
        ) : null)}
    </>
  );
};

export default Treatmentpackages;
